var site;

site = site || {};

(function ($) {
  Drupal.behaviors.fragranceFinderFormatterV1 = {
    currentQuestionIndex: 0,
    currentQuestionAnswer: '',
    $html: $('html, body'),
    attach: function (context) {
      var self = this;
      var $modules = $('.js-fragrance-finder-formatter', context);

      $modules.each(function () {
        var $module = $(this);

        self.getDom($module);
        self.getProps($module);
        self.setInits($module);
        self.setListeners($module);
      });
    },
    getDom: function ($module) {
      $module.nodes = {};
      $module.nodes.questions = $('.js-fragrance-finder-question-formatter', $module);
      $module.nodes.backArrow = $('.js-fragrance-finder-formatter-arrow', $module);
      $module.nodes.contentHeader = $('.js-fragrance-finder-formatter-content', $module);
      $module.nodes.result = $('.js-fragrance-finder-result-panel', $module);
      $module.nodes.resultFormatter = $('.js-fragrance-finder-result-formatter', $module);
      $module.nodes.startOver = $('.js-fragrance-finder-result-formatter-cta', $module);
      $module.nodes.steps = $('.js-fragrance-finder-formatter-steps', $module);
      $module.nodes.stepsCounter = $module.nodes.steps.find('.js-fragrance-finder-formatter-steps-counter');
      $module.nodes.stepsChidren;
    },
    getProps: function ($module) {
      $module.props = {};
      $module.props.questionCount = $module.nodes.questions.length;
      $module.props.currentQuestionIndex = 0;
      $module.props.currentQuestionAnswer = '';
    },
    setInits: function ($module) {
      var self = this;

      self.stepsSetup($module);
      $module.nodes.startOver.removeClass('button--light-navy-border').addClass('button_style_dark');
    },
    setListeners: function ($module) {
      var self = this;

      $module.nodes.backArrow.once().on('click', function () {
        self.updateActiveQuestion(
          $module,
          self.currentQuestionIndex - 2,
          self.currentQuestionIndex - 1
        );
        self.backStep($module);
        $module.nodes.resultFormatter.addClass('hidden');
      });

      $module.nodes.startOver.once().on('click', function () {
        $module.nodes.questions.addClass(
          'fragrance-finder-question-formatter__options--hide'
        );
        $module.nodes.questions
          .eq(0)
          .removeClass('fragrance-finder-question-formatter__options--hide');
        $module.nodes.resultFormatter.addClass('hidden');
        $module.attr('data-answer', '');
        $.event.trigger({
          type: 'fragrance_finder_formatter:start_over',
          payload: {
            $el: $module.nodes.startOver.closest('.js-fragrance-finder-formatter')
          }
        });
        $.event.trigger({
          type: 'fragrance_finder_formatter:current_index_update',
          payload: {
            currentIndex: 1
          }
        });
        self.currentQuestionIndex = 1;
        self.backStep($module);
        self.moveTop($module);
      });
      $module.nodes.stepsChidren.each(function (stepIndex) {
        $(this)
          .once()
          .on('click', function () {
            if (stepIndex + 1 < self.currentQuestionIndex) {
              self.updateActiveQuestion($module, stepIndex);
              self.backStep($module);
            }
          });
      });
      $(document).on('fragrance_finder_question_formatter:question_change', function (e) {
        self.currentQuestionIndex = e.payload['counter'];
        if (e.payload['answer']) {
          self.currentQuestionAnswer = e.payload['answer'];
        }
        self.updateSteps($module);
        self.checkBackArrow($module);
      });
      $(document).on('fragrance_finder_question_formatter:results_ready', function () {
        var $tout = $module.find(
          '.js-fragrance-finder-result-formatter-tout'
        );
        var $slick;
        var currentSettings;
        var $slicks = $tout.find('.slick-initialized');

        $slicks.each(function () {
          $slick = $(this);
          $slick.slick('unslick');
          currentSettings = {
            slidesToShow: $slick.slick('slickGetOption', 'slidesToShow'),
            slidesToScroll: $slick.slick('slickGetOption', 'slidesToScroll'),
            infinite: $slick.slick('slickGetOption', 'infinite'),
            dots: $slick.slick('slickGetOption', 'dots'),
            arrows: $slick.slick('slickGetOption', 'arrows'),
            rtl: site.direction.isRTL,
            responsive: $slick.slick('slickGetOption', 'responsive')
          };
          setTimeout(function () {
            $slick.slick(currentSettings);
          }, 500);
        });
      });
    },
    moveTop: function ($module) {
      var self = this;

      self.$html.animate(
        {
          scrollTop: $module.offset().top - 100
        },
        500
      );
    },
    backStep: function ($module) {
      var self = this;

      self.checkBackArrow($module);

      $module.nodes.contentHeader.removeClass('inactive');
      self.updateSteps($module);
    },
    updateAnswer: function ($module, nextIndex) {
      var selectedAnswers = $module.attr('data-answer').split(',');
      var updatedAnsSet;
      var newAnswers;

      newAnswers = selectedAnswers.slice(0, nextIndex);
      updatedAnsSet = newAnswers.join();
      if (nextIndex > 0) {
        updatedAnsSet = updatedAnsSet + ',';
      }
      $module.attr('data-answer', updatedAnsSet);
    },
    updateActiveQuestion: function ($module, nextIndex, currentIndex) {
      var self = this;

      $module.nodes.questions.addClass('fragrance-finder-question-formatter__options--hide');
      $module.nodes.questions.eq(nextIndex).removeClass('fragrance-finder-question-formatter__options--hide');
      self.updateAnswer($module, nextIndex);
      currentIndex
        ? (self.currentQuestionIndex = currentIndex)
        : (self.currentQuestionIndex = nextIndex + 1);
      $.event.trigger({
        type: 'fragrance_finder_formatter:current_index_update',
        payload: {
          currentIndex: self.currentQuestionIndex
        }
      });
    },
    checkBackArrow: function ($module) {
      var self = this;

      if (self.currentQuestionIndex <= 1) {
        $module.nodes.backArrow.removeClass('fragrance-finder-formatter__arrow--show');
      } else if (self.currentQuestionIndex > 1) {
        $module.nodes.backArrow.addClass('fragrance-finder-formatter__arrow--show');
      }
    },
    updateSteps: function ($module) {
      var self = this;

      $module.nodes.stepsChidren.removeClass('fragrance-finder-formatter__steps-counter--active');
      $module.nodes.stepsChidren
        .eq(self.currentQuestionIndex - 1)
        .addClass('fragrance-finder-formatter__steps-counter--active');
      $module.nodes.stepsChidren.removeClass('cursor-active');
      $module.nodes.stepsChidren.each(function (index) {
        if (index < self.currentQuestionIndex - 1) {
          $(this).addClass('cursor-active');
        }
      });
    },
    stepsSetup: function ($module) {
      var counterHtml = '';
      var i;

      for (i = 0; i < $module.props.questionCount; i++) {
        counterHtml +=
          '<span class="fragrance-finder-formatter__steps-counter--' +
          i +
          '"> </span>';
      }
      $module.nodes.stepsCounter.html(counterHtml);
      $module.nodes.stepsCounter
        .find('.fragrance-finder-formatter__steps-counter--0')
        .addClass('fragrance-finder-formatter__steps-counter--active');
      $module.nodes.stepsChidren = $module.nodes.stepsCounter.children();
    }
  };
})(jQuery);
